<div class="container-content">
    <div class="content">
        <div class="content-section">
            <div class="wrapper wrapper--large">
                <revenue-widget></revenue-widget>
            </div>
        </div>
    </div>
</div>